import { useContent } from "@/i18n";
import { firm } from "@/config/firm.config";
import { Reveal } from "./Reveal";
import { Eyebrow } from "./SectionHeading";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1505664194779-8beaceb93744?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const About = () => {
  const { t } = useContent();
  return (
    <section id="about" data-testid="about-section" className="relative bg-navy-900 py-28 md:py-40">
      <div className="mx-auto grid max-w-[1440px] gap-16 px-6 md:px-12 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Eyebrow>{t.about.eyebrow}</Eyebrow>
              <h2 className="mt-6 font-serif text-3xl font-light tracking-tight text-paper sm:text-4xl lg:text-5xl">{t.about.title}</h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-ink">{t.about.intro}</p>
            </Reveal>
            <Reveal delay={0.15} className="mt-12">
              <figure className="relative max-w-sm">
                <div className="relative aspect-[4/5] overflow-hidden [clip-path:polygon(0_0,100%_0,100%_88%,88%_100%,0_100%)]">
                  <img src={ABOUT_IMG} alt={t.about.imageAlt} loading="lazy" className="h-full w-full object-cover grayscale-[30%] transition-transform duration-[1.6s] ease-out hover:scale-[1.04]" />
                  <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_15%,rgba(224,184,120,0.28),transparent_50%),linear-gradient(180deg,rgba(11,16,35,0.15),rgba(11,16,35,0.75))]" />
                </div>
                <span aria-hidden="true" className="absolute -bottom-3 -left-3 h-12 w-12 border-b border-l border-gold" />
                <figcaption className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-ink/60">
                  {firm.address.line2}, {firm.city} · {firm.court}
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </div>

        <ol className="lg:col-span-6 lg:col-start-7" data-testid="about-chapters">
          {t.about.chapters.map((c, i) => (
            <Reveal key={c.n} delay={0.08 * i} as="li" className="border-t border-white/10 first:border-t-0">
              <div className="group grid gap-6 py-12 first:pt-0 md:grid-cols-12">
                <span aria-hidden="true" className="font-serif text-5xl font-light leading-none text-gold/50 transition-colors duration-500 group-hover:text-gold md:col-span-3 md:text-6xl">
                  {c.n}
                </span>
                <div className="md:col-span-9">
                  <h3 className="font-serif text-2xl text-paper sm:text-3xl">{c.title}</h3>
                  <p className="mt-4 text-base leading-relaxed text-ink">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
